module.exports = __webpack_public_path__ + "static/yakimaValleyLogoHeader2-cfc0b4a6b17616d0eb4de0cd95388169.png";